<template>
  <div class="content create-written-off-order">
    <div class="form-content">
      <a-tabs v-model="written_off_type" @change="init">
        <a-tab-pane key="RECEIVABLE_RECEIPT" :tab="$t('应收收款')" />
        <a-tab-pane key="RECEIVABLE_REFUND" :tab="$t('应收退款')" />
        <a-tab-pane key="RECEIVABLE_HEDGE" :tab="$t('应收对冲')" />
      </a-tabs>
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :code.sync="form_data.business_unit_code"
            :name.sync="form_data.business_unit_name"
            :placeholder="$t(`结算组织`)"
          />
        </a-col>
        <a-col :span="6">
          <CommonQuerySelect
            api="getAccountDimensionItemList"
            paginate
            :placeholder="$t('客户')"
            :code.sync="form_data.customer_code"
            :params="{
              businessUnitCode: form_data.business_unit_code,
              type: 'customer',
            }"
          />
        </a-col>
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="opertate-btns flex-ct">
      <a-button type="primary" @click="onSubmit" :loading="save_loading">
        {{ $t('生成应收核销单') }}
      </a-button>
    </div>
    <div class="receivable-list mt10">
      <div class="infoTitle" style="margin-bottom: 0">
        <div>
          <i class="leftLine"></i>
          <span>{{ $t('应收单列表') }}</span>
        </div>
        <div class="pr20 totla-amount flex-ct" v-if="total_receivable_amount">
          <span style="font-weight: 400" class="fz14 mr10">{{ $t('本次核销金额') }}:</span>
          <PriceInput :showTxt="true" :value="total_receivable_amount" />
        </div>
      </div>
      <CommonTable
        ref="CommonTableRef1"
        :columns.sync="columns1"
        :loading="loading1"
        :dataSource="table_data1"
        :showSelect="true"
        :scroll="{ x: 1500, y: scroll_height }"
        rowKey="doc_detail_id"
        :selectedRowKeys.sync="selected_row_keys1"
        :selectedRows.sync="selected_rows1"
        :total="total1"
        @select="selectRow1"
        @search="getList1"
      >
        <template v-slot:order_sn="{ record }">
          <a @click="viewDetail1(record)">{{ record.order_sn }}</a>
        </template>
        <template v-slot:receivableAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :currency="record.functionalCurrency"
            :value="record.receivableAmount"
          />
        </template>
        <template v-slot:unWrittenOffAmount="{ record }">
          <PriceInput
            :showTxt="true"
            :currency="record.functionalCurrency"
            :value="record.unWrittenOffAmount"
          />
        </template>
        <template v-slot:amount="{ record }">
          <PriceInput
            :currency="record.functionalCurrency"
            :value.sync="record.amount"
            @blur="
              (val) => {
                onBlur1(val, record)
              }
            "
          />
        </template>
      </CommonTable>
    </div>
    <div class="receipt-note-list mt20">
      <div class="infoTitle" style="margin-bottom: 0">
        <div>
          <i class="leftLine"></i>
          <span>{{ table2_label }}</span>
        </div>
        <div class="pr20 totla-amount flex-ct" v-if="total_receipt_amount">
          <span style="font-weight: 400" class="fz14 mr10">{{ $t('本次核销金额') }}:</span>
          <PriceInput :showTxt="true" :value="total_receipt_amount" />
        </div>
      </div>
      <CommonTable
        ref="CommonTableRef2"
        :columns.sync="columns2"
        :loading="loading2"
        :dataSource="table_data2"
        :showSelect="true"
        :scroll="{ x: 1500, y: scroll_height }"
        rowKey="doc_detail_id"
        :selectedRowKeys.sync="selected_row_keys2"
        :selectedRows.sync="selected_rows2"
        :total="total2"
        @select="selectRow2"
        @search="getList2"
      >
        <template v-slot:refer_doc_sn="{ text, record }">
          <a @click="viewDetail2(record)">{{ text }}</a>
        </template>
        <template v-slot:refer_amount="{ text, record }">
          <PriceInput
            :value="text"
            :currency="record.functional_currency || record.settlement_currency"
            :showTxt="true"
          />
        </template>
        <template v-slot:un_written_off_amount="{ text, record }">
          <PriceInput
            :value="text"
            :currency="record.functional_currency || record.settlement_currency"
            :showTxt="true"
          />
        </template>
        <template v-slot:amount="{ record }">
          <PriceInput
            :value.sync="record.amount"
            :currency="record.receiptCurrency"
            @blur="onBlur2(record)"
          />
        </template>
      </CommonTable>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@/component/commonTable'
import debounce from '@/common/debounce'
import { add, subtract } from '@/common/number'
export default {
  name: 'CreateWrittenOffOrder',
  components: { CommonTable },
  data() {
    return {
      written_off_type: 'RECEIVABLE_RECEIPT',
      form_data: {
        business_unit_code: undefined,
        business_unit_name: undefined,
        customer_code: undefined,
        can_write_off: true,
      },
      table_data1: [],
      table_data2: [],
      selected_row_keys1: [],
      selected_row_keys2: [],
      selected_rows1: [],
      selected_rows2: [],
      total1: 0,
      total2: 0,
      loading1: false,
      loading2: false,
      save_loading: false,
    }
  },
  activated() {
    const type = this.$route.query.written_off_type
    if (type) {
      this.written_off_type = type
    }
    this.init()
  },
  computed: {
    ...mapGetters([
      'receivableOrderTypeMapping',
      'receiptNoteTypeMapping',
      'paymentNoteTypeMapping',
    ]),
    scroll_height() {
      return window.innerHeight - 780
    },
    table2_label() {
      const map = {
        RECEIVABLE_RECEIPT: this.$t('收款单列表'),
        RECEIVABLE_REFUND: this.$t('付款单列表'),
        RECEIVABLE_HEDGE: this.$t('应收单列表'),
      }
      return map[this.written_off_type] || this.$t('关联单列表')
    },
    columns1() {
      return [
        {
          dataIndex: 'order_sn',
          title: this.$t('应收单号'),
          key: 'order_sn',
          scopedSlots: { customRender: 'order_sn' },
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('业务日期'),
          dataIndex: 'biz_date',
          customRender: (text) => text?.split(' ')?.[0],
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'order_type',
          width: 120,
          customRender: (text) => this.receivableOrderTypeMapping[text],
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('客户'),
          dataIndex: 'customer_name',
          customCell: (record, index) => this.customCell1('order_sn', record, index),
        },
        {
          title: this.$t('应收金额'),
          dataIndex: 'receivable_amount',
          width: 150,
          scopedSlots: { customRender: 'receivableAmount' },
        },
        {
          title: this.$t('未核销金额'),
          dataIndex: 'un_written_off_amount',
          width: 150,
          scopedSlots: { customRender: 'unWrittenOffAmount' },
        },
        {
          title: this.$t('本次核销金额'),
          dataIndex: 'amount',
          width: 200,
          scopedSlots: { customRender: 'amount' },
        },
      ]
    },
    columns2() {
      const sn_map = {
        RECEIVABLE_RECEIPT: { title: this.$t('收款单号'), dataIndex: 'receipt_note_sn' },
        RECEIVABLE_REFUND: { title: this.$t('付款单号'), dataIndex: 'payment_note_sn' },
        RECEIVABLE_HEDGE: { title: this.$t('应收单号'), dataIndex: 'order_sn' },
      }
      const config = sn_map[this.written_off_type] || {
        title: this.$t('关联单号'),
        dataIndex: 'refer_doc_sn',
      }
      const sn_key = config.dataIndex
      return [
        {
          title: config.title,
          dataIndex: config.dataIndex,
          scopedSlots: { customRender: 'refer_doc_sn' },
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('业务日期'),
          dataIndex: 'biz_date',
          customRender: (text) => text?.split(' ')?.[0],
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('单据类型'),
          dataIndex: 'order_type',
          width: 120,
          customRender: (text) => {
            if (this.written_off_type === 'RECEIVABLE_RECEIPT')
              return this.receiptNoteTypeMapping[text]
            if (this.written_off_type === 'RECEIVABLE_REFUND')
              return this.paymentNoteTypeMapping[text]
            return this.receivableOrderTypeMapping[text]
          },
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('客户'),
          dataIndex: 'customer_name',
          customCell: (record, index) => this.customCell2(sn_key, record, index),
        },
        {
          title: this.$t('单据金额'),
          dataIndex:
            this.written_off_type === 'RECEIVABLE_RECEIPT'
              ? 'receivable_amount'
              : this.written_off_type === 'RECEIVABLE_REFUND'
              ? 'payable_amount'
              : 'receivable_amount',
          scopedSlots: { customRender: 'refer_amount' },
          width: 150,
        },
        {
          title: this.$t('未核销金额'),
          dataIndex: 'un_written_off_amount',
          scopedSlots: { customRender: 'un_written_off_amount' },
          width: 150,
        },
        {
          title: this.$t('本次核销金额'),
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          width: 200,
        },
      ]
    },
    total_receivable_amount() {
      return this.selected_rows1.reduce((total, item) => {
        return add(total, item.amount)
      }, 0)
    },
    total_receipt_amount() {
      return this.selected_rows2.reduce((total, item) => {
        return add(total, item.amount)
      }, 0)
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    init() {
      this.selected_row_keys1 = []
      this.selected_row_keys2 = []
      this.selected_rows1 = []
      this.selected_rows2 = []
      this.searchHandle()
    },
    searchHandle(page_no) {
      this.searchHandle1(page_no)
      this.searchHandle2(page_no)
    },
    searchHandle1(page_no) {
      this.selected_row_keys1 = []
      this.$refs.CommonTableRef1?.queryList(page_no)
    },
    searchHandle2(page_no) {
      this.selected_row_keys2 = []
      this.$refs.CommonTableRef2?.queryList(page_no)
    },
    mergeCells(text, data, key, index) {
      if (index !== 0 && text === data[index - 1]?.[key]) {
        return 0
      }
      let rowSpan = 1
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) break
        rowSpan++
      }
      return rowSpan
    },
    customCell1(key, record, index) {
      const rowSpan = this.mergeCells(record[key], this.table_data1, key, index)
      return rowSpan > 0
        ? { attrs: { rowSpan } }
        : { style: { display: 'none' }, attrs: { rowSpan: 0 } }
    },
    customCell2(key, record, index) {
      const rowSpan = this.mergeCells(record[key], this.table_data2, key, index)
      return rowSpan > 0
        ? { attrs: { rowSpan } }
        : { style: { display: 'none' }, attrs: { rowSpan: 0 } }
    },
    async getList1(params) {
      this.loading1 = true
      await http({
        url: api.getReceivableList,
        data: {
          ...this.form_data,
          ...params,
          ...(this.written_off_type === 'RECEIVABLE_REFUND'
            ? { amountGlZero: 0 }
            : this.written_off_type === 'RECEIVABLE_HEDGE'
            ? { amountGlZero: 1 }
            : {}),
        },
        success: (res) => {
          let list = []
          res.result.list.forEach((item) => {
            const plan_list = item.receipt_plan_list || []
            plan_list.forEach((elem) => {
              let un_written_off_amount = subtract(
                elem.receivable_amount,
                elem.written_off_amount || 0
              )
              list.push({
                ...item,
                doc_detail_id: elem.id,
                un_written_off_amount,
                amount: un_written_off_amount,
              })
            })
          })
          this.table_data1 = list
          this.total1 = res.result.total
        },
      })
      this.loading1 = false
    },
    async getList2(params) {
      this.loading2 = true
      const url_map = {
        RECEIVABLE_RECEIPT: api.getReceiptNoteList,
        RECEIVABLE_REFUND: api.getPaymentNoteList,
        RECEIVABLE_HEDGE: api.getReceivableList,
      }
      const url = url_map[this.written_off_type]
      if (!url) return
      await http({
        url,
        data: {
          ...this.form_data,
          ...params,
          ...(this.written_off_type === 'RECEIVABLE_HEDGE' ? { amountGlZero: 0 } : {}),
        },
        success: (res) => {
          let list = []
          res.result.list.forEach((item) => {
            if (this.written_off_type === 'RECEIVABLE_RECEIPT') {
              const items = item.items || []
              items.forEach((elem) => {
                let un_written_off_amount = subtract(
                  elem.receivable_amount,
                  elem.verified_amount || 0
                )
                list.push({
                  ...item,
                  doc_detail_id: elem.id,
                  receivable_amount: elem.receivable_amount,
                  un_written_off_amount,
                  amount: un_written_off_amount,
                })
              })
            } else if (this.written_off_type === 'RECEIVABLE_REFUND') {
              const detail_list = item.items || item.detail_list || []
              detail_list.forEach((elem) => {
                let un_written_off_amount = subtract(
                  elem.payable_amount,
                  elem.written_off_amount || 0
                )
                list.push({
                  ...item,
                  doc_detail_id: elem.id,
                  payable_amount: elem.payable_amount,
                  un_written_off_amount,
                  amount: un_written_off_amount,
                })
              })
            } else {
              // RECEIVABLE_HEDGE
              const plan_list = item.receipt_plan_list || []
              plan_list.forEach((elem) => {
                let un_written_off_amount = subtract(
                  elem.receivable_amount,
                  elem.written_off_amount || 0
                )
                list.push({
                  ...item,
                  doc_detail_id: elem.id,
                  receivable_amount: elem.receivable_amount,
                  un_written_off_amount,
                  amount: un_written_off_amount,
                })
              })
            }
          })
          this.table_data2 = list
          this.total2 = res.result.total
        },
      })
      this.loading2 = false
    },
    viewDetail1(record) {
      this.addPane({
        view: 'receivableManage/receivableDetail/' + record.order_sn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.order_sn,
        },
        route: `/receivableManage/receivableDetail?id=${record.id}&sn=${record.order_sn}`,
      })
    },
    viewDetail2(record) {
      let view = 'receivableManage/receiptNoteDetail/' + record.receipt_note_sn
      let sn = record.receipt_note_sn
      let route = `/receivableManage/receiptNoteDetail?id=${record.id}&sn=${sn}`

      if (this.written_off_type === 'RECEIVABLE_REFUND') {
        view = 'payableManage/paymentNoteDetail/' + record.payment_note_sn
        sn = record.payment_note_sn
        route = `/payableManage/paymentNoteDetail?id=${record.id}&sn=${sn}`
      } else if (this.written_off_type === 'RECEIVABLE_HEDGE') {
        view = 'receivableManage/receivableDetail/' + record.order_sn
        sn = record.order_sn
        route = `/receivableManage/receivableDetail?id=${record.id}&sn=${sn}`
      }

      this.addPane({
        view,
        name: 'detailSn',
        query: {
          id: record.id,
          sn,
        },
        route,
      })
    },
    onSubmit: debounce(async function () {
      if (this.selected_row_keys1.length === 0) {
        this.$message.warning(this.$t('请选择应收单'))
        return
      }
      const label_map = {
        RECEIVABLE_RECEIPT: this.$t('请选择收款单'),
        RECEIVABLE_REFUND: this.$t('请选择付款单'),
        RECEIVABLE_HEDGE: this.$t('请选择被核销应收单'),
      }
      if (this.selected_row_keys2.length === 0) {
        this.$message.warning(label_map[this.written_off_type])
        return
      }
      this.save_loading = true
      const refer_doc_type_map = {
        RECEIVABLE_RECEIPT: 'ReceiptNote',
        RECEIVABLE_REFUND: 'PaymentNote',
        RECEIVABLE_HEDGE: 'ReceivableOrder',
      }
      await http({
        url: api.createWrittenOff,
        data: {
          written_off_type: this.written_off_type,
          main_doc_list: this.selected_rows1.map((item) => ({
            amount: item.amount,
            doc_detail_id: item.doc_detail_id,
            doc_id: item.id,
            doc_type: 'ReceivableOrder',
          })),
          refer_doc_list: this.selected_rows2.map((item) => ({
            amount: item.amount,
            doc_detail_id: item.doc_detail_id,
            doc_id: item.id,
            doc_type: refer_doc_type_map[this.written_off_type],
          })),
        },
        type: 'post',
        hasLoading: true,
        success: (res) => {
          if (res.success) {
            this.$success({
              title: this.$t(`成功`),
              content: this.$t('核销单创建成功'),
            })
            this.init()
          } else {
            this.$error({
              title: this.$t(`错误`),
              content: this.$t(`创建失败`),
            })
          }
        },
      })
      this.save_loading = false
    }),
    backForm(back = 0) {
      if (back) {
        this.$router.go(-1)
        return
      }
      this.$router.push({ name: 'writtenOffOrderList' })
    },
    selectRow1(selected_row_keys, selected_rows) {
      this.selected_row_keys1 = selected_row_keys
      this.selected_rows1 = selected_rows
    },
    selectRow2(selected_row_keys, selected_rows) {
      this.selected_row_keys2 = selected_row_keys
      this.selected_rows2 = selected_rows
    },
    onBlur1(val, record) {
      if (val && !this.selected_row_keys1.includes(record.doc_detail_id)) {
        this.selected_row_keys1.push(record.doc_detail_id)
        this.selected_rows1.push(record)
      }
    },
    onBlur2(record) {
      if (record.amount && !this.selected_row_keys2.includes(record.doc_detail_id)) {
        this.selected_row_keys2.push(record.doc_detail_id)
        this.selected_rows2.push(record)
      }
    },
  },
}
</script>
<style scoped>
.bottom-btns {
  justify-content: center;
  margin-top: 30px;
}
.infoTitle {
  justify-content: space-between;
}
</style>
